import createReactComponent from '../createReactComponent';
export default createReactComponent('a-b', 'IconAB', [
  ['path', { d: 'M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5', key: 'svg-0' }],
  ['path', { d: 'M12 6l0 12', key: 'svg-1' }],
  [
    'path',
    { d: 'M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3', key: 'svg-2' },
  ],
]);
